import React from "react";
import './Contact.css';

const Contact = () => {
    return (
        <section className="contact-section" id="contact">
            <h2 className="numbered-heading overline">04. What’s Next?</h2>
            <h2 className="title">Get In Touch</h2>
            <p>
                We can have discussion whenever you want, my inbox is always open.
                Whether you have a question or just want to say hi, I’ll try my best to get back to you!
            </p>

            <a className="primary-button" href={`mailto:py.usman.ali@gmail.com`}>
                Say Hello
            </a>
            <span className="">
                Build by @Usman Ali
            </span>
        </section>
    )
}

export default Contact
